import axiosInstance from './apiConfig';

export const getAllOrganization = async (
  id: string = null,
  search: string = '',
  userId: number,
): Promise<any> => {
  try {
    let url = '/organization/getAll';
    const params = new URLSearchParams();

    if (id) params.append('organizationId', String(id));
    if (search) params.append('search', search);
    if (userId) params.append('userId', String(userId));

    if (params.toString().length > 0) {
      url += '?' + params.toString();
    }

    const response = await axiosInstance.get(url);

    return response.data;
  } catch (error) {
    throw new Error(`fetch organization failed: ${error}`);
  }
};

export const addNewOrganization = async (data: any): Promise<any> => {
  try {
    const response = await axiosInstance.post('/organization/add', data);

    return response.data;
  } catch (error) {
    throw new Error(`add organization failed: ${error}`);
  }
};

export const editNewOrganization = async (
  id: number,
  data: any,
): Promise<any> => {
  try {
    const response = await axiosInstance.put(
      '/organization/update?id=' + id,
      data,
    );

    return response.data;
  } catch (error) {
    throw new Error(`edit organization failed: ${error}`);
  }
};

export const removeOrg = async (orgId: string): Promise<any> => {
  const response = await axiosInstance.delete(
    '/organization/delete?id=' + orgId,
  );

  return response.data;
};

export const exportOrganizations = async (): Promise<Blob> => {
  try {
    const response = await axiosInstance.get('/organization/export', {
      responseType: 'blob',
    });

    return response.data;
  } catch (error) {
    throw new Error(`export organizations failed: ${error}`);
  }
};

export const uploadOrganizations = async (file: File): Promise<any> => {
  const data = new FormData();
  data.append('file', file);

  try {
    const response = await axiosInstance.post('/organization/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};
